import { matchSorter } from "match-sorter";
import React, { FunctionComponent } from "react";
import { Table } from "react-bootstrap";
import { FilterValue, Row, useFilters, useSortBy, useTable } from "react-table";

interface IProps {
	columns: object[];
	data: object[];
	defaultFiltered?: any;
}

function fuzzyTextFilterFn(rows: Row[], id: number, filterValue: FilterValue) {
	return matchSorter(rows, filterValue, {
		keys: [(row: Row) => row.values[id]],
	});
}

fuzzyTextFilterFn.autoRemove = (val: string) => !val;

function DefaultColumnFilter({
	column: { filterValue, preFilteredRows, setFilter },
}: any) {
	const count = preFilteredRows.length;

	return (
		<input
			value={filterValue || ""}
			className="form-control"
			onChange={e => {
				setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
			}}
			placeholder={`Search ${count} records...`}
		/>
	);
}

export const DataTable: FunctionComponent<IProps> = props => {
	const defaultColumn = React.useMemo(
		() => ({
			Filter: DefaultColumnFilter,
		}),
		[],
	);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow,
	} = useTable(
		{
			columns: props.columns,
			data: props.data,
			defaultColumn,
		},
		useFilters,
		useSortBy,
	);

	return (
		<Table striped bordered hover {...getTableProps()}>
			<thead>
				{headerGroups.map((headerGroup: any) => (
					<tr {...headerGroup.getHeaderGroupProps()}>
						{headerGroup.headers.map((column: any) => (
							<th
								{...column.getHeaderProps(
									column.getSortByToggleProps(),
								)}
								width={column.width}
							>
								{column.render("Header")}
								{column.isSorted
									? column.isSortedDesc
										? " 🔽"
										: " 🔼"
									: ""}
								{column.canFilter
									? column.render("Filter")
									: null}
							</th>
						))}
					</tr>
				))}
			</thead>
			<tbody {...getTableBodyProps()}>
				{rows.map((row: any) => {
					prepareRow(row);
					return (
						<tr {...row.getRowProps()}>
							{row.cells.map((cell: any) => {
								return (
									<td {...cell.getCellProps()}>
										{cell.render("Cell")}
									</td>
								);
							})}
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
};
